import React, { useEffect, useRef, useState } from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import TeacherCard from './TeacherCard'
import { observer } from 'mobx-react'
import style from '../MainInfo.module.scss'

function GroupTeachers(props) {
  const refBox = useRef()

  const [teachers, setTeachers] = useState([])
  // const teachers = props.teachers

  useEffect(() => {
    setTeachers(props.teachers.slice(0, 2))
  }, [])

  const showAllTeacher = () => {
    setTeachers([...props.teachers])
  }

  return (
    <div className={style.groupSimpleMainBox__col__card}>
      <div className={style.groupSimpleMainBox__cardHeader}>
        {props.translate.group_teachers}
      </div>
      <div className={style.groupSimpleMainBox__teachers} ref={refBox}>
        {props.teachers.length > 0 ? (
          teachers.map((item) => (
            <TeacherCard teacher={item} key={item.id} refBox={refBox} />
          ))
        ) : (
          <div className={style.notFoundTeachers}>
            The group has no teachers yet. You need to add a schedule with a
            teacher.
          </div>
        )}

        {props.teachers.length > 2 && (
          <div className={style.groupSimpleMainBox__teachers__showAll}>
            <button onClick={showAllTeacher}>Show All Teachers</button>
          </div>
        )}
      </div>

      <div id='teacherTooltip' />
    </div>
  )
}

export default observer(GroupTeachers)
